import React from "react";
import ComponentePermissao from "@/Components/Base/Permissao/ComponentePermissao";
import { Button, Grid } from "antd";
import TypeViagem from "@/Models/Domain/Viagem/Viagem";
import Titulo, {_TituloSemRecursao, EnumTituloTipo } from "@/Models/Financeiro/Titulo/Titulo";
import { useListar as useListarTitulos } from "@/Services/Financeiro/Titulo/TituloService";
import { EnumOrigemTipo } from "@/Models/Financeiro/Titulo/Origem/OrigemTipo";
import ResponsiveAntdTable from "@/Components/ResponsiveAntdTable";

import Formatacoes from "@/Utils/Formatacao";
import Conjunto from "@/Components/Conjunto";
import { EnumTituloSituacao } from "@/Models/Financeiro/Titulo/TituloSituacao";
import { ReciboModal } from "./Recibo";
import TituloCadastroModalModal from "../../Financeiro/Titulo/TituloCadastroModal";
import Utilitario from "@/Utils/Utilitario";
import { EnumPessoaTipo } from "@/Models/Pessoa/Pessoa";

export const ReciboDaViagemScreen: React.FC<{
    viagem: TypeViagem
}> = ({viagem, ...props}) => {
    const breakpoint = Grid.useBreakpoint();

    const { data: queryData, ...query } = useListarTitulos({
        enabled: true,
        ativo: true,
        titulo: {
            codDevedor: viagem.escola?.pessoa?.codigo,
            // codSituacao: EnumTituloSituacao.Liquidado,
            codTipo: EnumTituloTipo.Parcela,
            origem: {
                codTipo: EnumOrigemTipo.Viagem,
                codReferencia : viagem.codigo
            },
        },
    });

    return (
        <ComponentePermissao permissoes={["ListarInscricoesDaViagem"]}>
            <ResponsiveAntdTable<Titulo, _TituloSemRecursao>
                dataSource={queryData}
                minGeneratedSpanWidth={breakpoint.lg ? 2 : breakpoint.sm ? 12 : 24}
                csv={{
                    enabled: true,
                    filename: "recibos.csv"
                }}
                columns={[
                    {
                        title: "Beneficiário",
                        dataIndex: ["beneficiario", "nome"],
                        key: "recibo-beneficiario",
                    },
                    {
                        title: "Devedor",
                        dataIndex: ["devedor", "nomeExibicao"],
                        key: "recibo-devedor",
                    },
                    {
                        title: "Previsto",
                        dataIndex: "valorPrevisto",
                        render: (val) => Formatacoes.formatarReal(val),
                        key: "recibo-previsto",

                        csv: {
                            title: "Previsto (R$)",
                            get: (record) => Utilitario.toCSVDinheiro(record?.valorPrevisto),
                        }
                    },
                    {
                        title: "Recebido",
                        dataIndex: "valorRecebido",
                        render: (val) => Formatacoes.formatarReal(val),
                        key: "recibo-recebido",

                        csv: {
                            title: "Recebido (R$)",
                            get: (record) => Utilitario.toCSVDinheiro(record?.valorRecebido),
                        }
                    },
                    {
                        title: "Situação",
                        dataIndex: ["situacao", "nome"],
                        key: "recibo-situacao",
                    },
                    {
                        title: "Ações",
                        key: "acoes",
                        noResponsiveTitle: true,
                        breakpoints: { xs: 24, sm: 24, lg: 5 },
                        csv: {
                            ignore: true
                        },
                        render: (_, item) => {
                            return (
                                <Conjunto
                                    style={{
                                        justifyContent: breakpoint.sm ? "unset" : "center",
                                        display: "flex",
                                        flexWrap: "wrap",
                                    }}
                                    itens={[
                                        <ReciboModal
                                            modalProps={{
                                                title: "Recibo da viagem",
                                                okText: "Fechar",
                                            }}
                                            reciboProps={{
                                                privilegio: "administrador",
                                                codigoDoTitulo: item.codigo,
                                                permitirEditarDescricao: true
                                            }}
                                            buttonOpen={<Button size="small" type="default">Detalhes</Button>}
                                        />,
                                        <ComponentePermissao permissoes={["FinanceiroTituloAlterar", "FinanceiroTituloBuscarCodigo"]}>
                                            <TituloCadastroModalModal 
                                                isAReceber={item.beneficiario?.tipo === EnumPessoaTipo.EMPRESA}
                                                codigo={item?.codigo ?? undefined}
                                            />
                                        </ComponentePermissao>
                                    ]}
                                />
                            );
                        },
                    },
                ]}
            />
        </ComponentePermissao>
    );
}
